<template>
  <div class="allbox">
    <div style="margin-bottom:20px;">
      <div class="condition">
        <el-input
          v-model="query.user_id"
          class="inptw"
          placeholder="请输入主账号id"
        />
        <el-input
          v-model="query.sub_uc_id"
          class="inptw"
          placeholder="请输入子账号"
        />
        <el-input
          v-model="query.creativeFeedId"
          class="inptw"
          placeholder="请输入创意id"
        />
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="search"
        >搜索</el-button>
      </div>
    </div>
    <el-table
      :data="baidudataList"
      highlight-current-row
      border
      style="width: 100%"
    >
      <el-table-column
        prop="creativeFeedId"
        label="创意id"
        width="120px"
      />
      <el-table-column
        prop="creativeFeedName"
        label="创意名称"
        width="180px"
      />
      <el-table-column
        prop="ideaTypeText"
        label="创意类型"
        width="150px"
      />
      <el-table-column
        prop="id"
        label="id"
        width="80px"
      />
      <el-table-column
        prop="pauseText"
        label="是否停止推广"
        width="80px"
      />
      <el-table-column
        prop="statusText"
        label="创意状态"
        width="80px"
      />
      <el-table-column
        prop="sub_uc_id"
        label="子账号userid"
        width="120px"
      />
      <el-table-column
        prop="commentnum"
        label="评论数"
        width="120px"
      />
      <el-table-column
        prop="readnum"
        label="阅读量"
        width="150px"
      />
      <el-table-column
        prop="playnum"
        label="创意视频播放量"
        width="150px"
      />
      <el-table-column
        prop="showMt"
        label="程序化创意展示样式"
        width="150px"
      />
      <el-table-column
        prop="addtime"
        label="创建时间"
        width="150px"
      />
      <el-table-column
        prop="adgroupFeedId"
        label="推广单元所属id"
        width="150px"
      />
      <el-table-column
        prop="materialstyle"
        label="创意样式id"
        width="150px"
      />
      <el-table-column
        label="审核未通过原因"
        width="150px"
      >
        <template slot-scope="scope">
          <el-button type="text" @click="openDrawer(scope.row.approvemsgnew)">点击查看详情</el-button>
        </template>
      </el-table-column><!--        prop="refusereason"-->
      <el-table-column
        prop="createTime"
        label="创建时间"
        width="150px"
      />
      <el-table-column
        prop="progFlag"
        label="程序化创意工具标识"
        width="150px"
      />
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <div>
      <el-drawer
        title="审核详细信息"
        :visible.sync="drawerVisible"
        size="50%"
        :with-header="true"
        @closed="handleClose"
      >
        <el-table
          :data="currentInfo"
          border
        >
          <el-table-column
            prop="videoId"
            label="元素id"
          />
          <el-table-column
            prop="field"
            label="field"
          />
          <el-table-column
            prop="message.audit_detail.text"
            label="详情信息"
          />
        </el-table>
      </el-drawer>
    </div>
  </div>
</template>

<script>

import { getBaiduADCreativeFeedList } from '@/api/baiduAD'
import PaginationRight from '@/components/PaginationRight/index.vue'

export default {
  components: { PaginationRight },
  data() {
    return {
      baidudataList: [],
      total: null,
      query: {
        user_id: '',
        page: 1,
        page_size: 10,
        creativeFeedId: null,
        sub_uc_id: null
      },
      drawerVisible: true,
      currentInfo: []
    }
  },
  created() {
    this.list()
  },
  methods: {
    list() {
      getBaiduADCreativeFeedList(this.query).then(res => {
        this.baidudataList = res.data.list
        this.total = res.data.total
      })
    },
    fetchPageSize(e) {
      this.query.page_size = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    search() {
      this.query.page = 1
      this.list()
    },
    openDrawer(row) {
      console.log(row)
      row.map(res => {
        if (res.message && res.field) {
          this.currentInfo.push(res)
        }
      })
      this.drawerVisible = true
    },
    handleClose() {
      this.currentInfo = []
    }
  }
}
</script>

<style scoped>
.allbox {
  padding: 30px;
}
.tag_box{
  margin: 0 10px 10px 0px;
}
.inptw {
  width: 250px;
}
.condition >* {
  margin-right: 10px;
}
</style>
